// extracted by mini-css-extract-plugin
module.exports = {"customTip":"TipsApplier_customTip__U1Vn0"};